import { Checkbox as _Checkbox } from '@base-ui/react/checkbox';
import clsx from 'clsx';
import { forwardRef } from '@wordpress/element';
import { check, reset } from '@wordpress/icons';
import { Icon } from '../../../icon';
import resetStyles from '../../../utils/css/resets.module.css';
import focusStyles from '../../../utils/css/focus.module.scss';
import styles from './style.module.css';
import type { CheckboxProps } from './types';

/**
 * A low-level checkbox primitive.
 *
 * Prefer `CheckboxControl` for labeled items. For grouping and nested parent
 * checkboxes, see the [Checkbox Groups](https://wordpress.github.io/gutenberg/?path=/docs/design-system-components-form-checkbox-groups--docs)
 * documentation.
 */
export const Checkbox = forwardRef< HTMLSpanElement, CheckboxProps >(
	function UnforwardedCheckbox(
		{ className, indeterminate, ...restProps },
		ref
	) {
		return (
			<_Checkbox.Root
				ref={ ref }
				className={ clsx(
					resetStyles[ 'box-sizing' ],
					focusStyles[ 'outset-ring--focus' ],
					styles.root,
					className
				) }
				indeterminate={ indeterminate }
				{ ...restProps }
			>
				<_Checkbox.Indicator
					className={ styles[ 'indicator-icon' ] }
					render={ ( props, state ) => (
						<Icon
							{ ...props }
							icon={ state.indeterminate ? reset : check }
							viewBox="4 4 16 16"
							size={ 16 }
						/>
					) }
				/>
			</_Checkbox.Root>
		);
	}
);
